import { z } from "zod";
/**
 * Zod schema for sweep account security symbols
 * These securities should not be eligible for DNS (Do Not Sell) restrictions
 * as they represent cash-like instruments used for transactions
 *
 * Following PQS approach of hardcoding these symbols for now
 * See: https://fartherfinance.slack.com/archives/C08JVNETUTZ/p1747073295782689?thread_ts=1747061828.982559&cid=C08JVNETUTZ
 */
export const sweepAccountSecuritySymbolsSchema = z.enum([
    "DGUXX",
    "FCASH",
    "FDRXX",
    "SPAXX",
    "FZDXX",
    "FZFXX",
    "GRFXX",
    "MMFRFI",
    "SCHWABMM",
    "ISPZZ",
    "BFBXX",
    "CEAXX",
    "QIWSQ",
]);
/**
 * Set of security symbols that represent sweep accounts
 */
export const SWEEP_ACCOUNT_SECURITY_SYMBOLS = new Set(Object.values(sweepAccountSecuritySymbolsSchema.enum));
//# sourceMappingURL=symbols.js.map